// removed by extract-text-webpack-plugin
module.exports = {"modalOpen":"uoXZr","modalOverlay":"_2aeAR","modal":"_1U1w6","modalHeader":"_3PiM-","modalHeaderTitle":"_27Fd-","modalHeaderBackButton":"_3Cthn","modalFooter":"aDzdh","modalFooterLeftButton":"_2newj","modalFooterRightButton":"_1Sbmm","rightSidebarModal":"_1lGd2","slideInFromRight":"_2BCwT","rightSidebarModalClosing":"FshxW","slideOutToRight":"_2wUm6"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Modal/index.sass
// module id = 1486
// module chunks = 1